import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserStorageService } from './storage.service';
import { SignatureStorageDataModel } from '../models/storage-data.model';

@Injectable({
  providedIn: 'root',
})
export class UserSignatureSelectedService {
  private themeList = [
    { id: 'SI0035', theme: 'biotherm-theme' },
    { id: 'SI0028', theme: 'ysl-theme' },
    { id: 'SI0030', theme: 'helenaRubinstein-theme' },
    { id: 'SI0036', theme: 'kiehls-theme' },
    { id: 'SI0124', theme: 'prada-theme' },
  ];

  private storageKey = 'UserSignatureSelected';

  private userSignatureDataSelectedSubject = new BehaviorSubject<
    SignatureStorageDataModel | undefined
  >(undefined);
  public userSignatureDataSelectedSubject$ =
    this.userSignatureDataSelectedSubject.asObservable();

  private userSignatureIdSelectedSubject = new BehaviorSubject<
    string | undefined
  >(undefined);
  public userSignatureIdSelectedSubject$ =
    this.userSignatureIdSelectedSubject.asObservable();

  private userAppServiceSelectedSubject = new BehaviorSubject<
    number | undefined
  >(undefined);
  public userAppServiceSelectedSubject$ =
    this.userAppServiceSelectedSubject.asObservable();

  constructor(private browserStorageService: BrowserStorageService) {
    const currentSignatureInfo: SignatureStorageDataModel | undefined =
      this.getUserSignatureInfoSelected();

    if (currentSignatureInfo) {
      this.userSignatureIdSelectedSubject.next(
        currentSignatureInfo.signatureId
      );
      this.userAppServiceSelectedSubject.next(
        currentSignatureInfo.appServiceId
      );
      this.userSignatureDataSelectedSubject.next(currentSignatureInfo);
      this.applyTheme(currentSignatureInfo.signatureId);
    }
  }

  getUserSignatureInfoSelected(): SignatureStorageDataModel | undefined {
    const signatureData = this.browserStorageService.get(this.storageKey);

    if (signatureData) {
      return JSON.parse(signatureData) as SignatureStorageDataModel;
    }

    return undefined;
  }

  updateUserSignatureSelected(signatureInfo: string): void {
    const signatureStorageData =
      this.getSignatureDataObjFromString(signatureInfo);

    if (!signatureStorageData) {
      return;
    }

    this.browserStorageService.set(
      this.storageKey,
      JSON.stringify(signatureStorageData)
    );
    this.userSignatureIdSelectedSubject.next(signatureStorageData.signatureId);
    this.userAppServiceSelectedSubject.next(signatureStorageData.appServiceId);
    this.userSignatureDataSelectedSubject.next(signatureStorageData);

    this.applyTheme(signatureInfo);
  }

  private applyTheme(signatureIdSelected: string): void {
    const bodyElement = document.body;
    if (bodyElement) {
      bodyElement.classList.remove(
        'biotherm-theme',
        'ysl-theme',
        'kiehls-theme',
        'helenaRubinstein-theme',
        'prada-theme'
      );

      if (signatureIdSelected) {
        const themeName = this.themeList.find(
          theme => theme.id === signatureIdSelected
        );

        if (themeName) {
          bodyElement.classList.add(themeName.theme);
        }
      }
    }
  }

  private getSignatureDataObjFromString(
    signatureInfo: string
  ): SignatureStorageDataModel | undefined {
    const signatureSelected = signatureInfo
      ? signatureInfo.split('_')[1]
      : undefined;

    if (!signatureSelected) {
      return undefined;
    }

    const appService = signatureInfo
      ? signatureInfo.split('_')[3]
        ? Number(signatureInfo.split('_')[3])
        : undefined
      : undefined;

    return { signatureId: signatureSelected, appServiceId: appService };
  }

  public getSignatureDataStringFromObj(
    signatureStorageData: SignatureStorageDataModel
  ): string {
    let signatureDataString = 'signature_' + signatureStorageData.signatureId;

    if (signatureStorageData.appServiceId) {
      signatureDataString =
        signatureDataString +
        '_appService_' +
        signatureStorageData.appServiceId;
    }

    return signatureDataString;
  }
}
